export const maintenanceTicketStatuses = {
  SCHEDULED: 'Scheduled',
  PROPOSED_SCHEDULED_DATE: 'proposed_scheduled_date',
  CONTRACTOR_NEEDED_REVIEW: 'Contractor Needed Review',
  PARTS_NEEDED_REVIEW: 'Parts Needed Review',
};
